import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langLocalNames from './lang_list'
import _ from 'lodash'

Vue.use(VueI18n)

if (window.base64data === undefined) {
  window.base64data = btoa(
    JSON.stringify({
      multilingualOption: {
        showLangOption: true,
      },
      customLanguages: {},
    }),
  )
}

const debugGetValue = (name) => {
  name = name.toLowerCase()
  const url = new URL(window.location.href)

  const result = url.searchParams.get(name)

  if (result) return result

  return ''
}

const campaignInfo = JSON.parse(atob(base64data))

const isMultilingual =
  _(campaignInfo).get('flags.showMultilingual') === true ||
  _(campaignInfo).get('flags.showMultilingual') === 'true'
const payloadVersion = _(campaignInfo).get('version') ? _(campaignInfo).get('version') : null

let hasCustomLanguages = campaignInfo.customLanguages !== undefined
if (hasCustomLanguages && Array.isArray(campaignInfo.customLanguages)) {
  hasCustomLanguages = false
}
const debugIndex = false
const debugLogger = (msg, ctx = undefined) => {
  if (debugIndex && !ctx) console.log(msg)
  if (debugIndex && !!ctx) console.log(msg, ctx)
}
debugLogger('Debug enabled')

function loadLocaleMessages() {
  // Vite's glob import - replaces Webpack's require.context
  const localeFiles = import.meta.glob('./*.json', { eager: true })

  const messages = {}

  Object.keys(localeFiles).forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = localeFiles[key].default || localeFiles[key]
      messages[locale].language_name = langLocalNames[key]
    }
  })

  // Handle special aliases
  if (localeFiles['./pt-PT.json']) {
    messages.pt = localeFiles['./pt-PT.json'].default || localeFiles['./pt-PT.json']
  }
  if (localeFiles['./ja.json']) {
    messages.jp = localeFiles['./ja.json'].default || localeFiles['./ja.json']
  }

  return messages
}

const messages = loadLocaleMessages()

const defaultEmptyTranslations = ['sub_title_text', 'footer_text']

for (const message in messages) {
  for (const emptyKey of defaultEmptyTranslations) {
    messages[message][emptyKey] = ''
  }
}

const fallbackLocale = 'en'
const locale = campaignInfo.langCode || fallbackLocale

const messages_default = messages[fallbackLocale]

// Set all missed keys from ENGLISH
for (const message in messages) {
  for (const message_default in messages_default) {
    if (!messages[message][message_default]) {
      messages[message][message_default] = messages_default[message_default]
    }
  }
}

// Only whitelisted keys can obtain null values from the custom languages
const canBeNullThroughCustomLanguages = ['title_text', 'sub_title_text', 'footer_text', 'support']

// Not all payloads have the `customLanguages` key
const customLanguages = hasCustomLanguages ? campaignInfo.customLanguages : {}

// Customize
// We trust empty values in the customLanguages if they are whitelisted to be empty.
// This is a safety for e.g. login btn texts to not be empty
for (const language in customLanguages) {
  if (['el-CY'].includes(language)) {
    // Force skip removed langs to be safe
    continue
  }

  for (const message in campaignInfo.customLanguages[language]) {
    const isNullOrUndefined =
      campaignInfo.customLanguages[language][message] === null ||
      campaignInfo.customLanguages[language][message] === undefined
    if (isNullOrUndefined === false) {
      messages[language][message] = campaignInfo.customLanguages[language][message]
    }

    if (isNullOrUndefined && canBeNullThroughCustomLanguages.includes(message)) {
      messages[language][message] = campaignInfo.customLanguages[language][message]
    }
  }
}

// i18n works with nulls & undefiends by printing the requested key instead of something empty
// While empty string print empty string
for (const message in messages) {
  for (const customKey in messages[message]) {
    if (messages[message][customKey] === null || messages[message][customKey] === undefined) {
      messages[message][customKey] = ''
    }
  }
}

if (debugIndex) {
  window.debug_box = {
    isMultilingual,
    payloadVersion,
    campaignInfo,
    messages,
    hasCustomLanguages,
    is_plume: debugGetValue('is_plume'),
    plume_post: debugGetValue('plume_post'),
    href: window.location.href,
  }
} else {
  window.debug_box = {
    isMultilingual,
    is_plume: debugGetValue('is_plume'),
    plume_post: debugGetValue('plume_post'),
    href: window.location.href,
  }
}

const i18n = new VueI18n({
  locale,
  fallbackLocale,
  messages,
  dateTimeFormats: {},
  numberFormats: {},
})

export { i18n, loadLocaleMessages }
